import { createReducer, on } from '@ngrx/store';
import { AppChooserDialogState } from './app-chooser-dialog.state';
import { appChooserDialogStateInitial } from './app-chooser-dialog.state.initial';
import { AppChooserDialogActions } from './app-chooser-dialog.actions';

/**
 * Reducer für den App-Chooser-Dialog.
 */
export const appChooserDialogReducers = createReducer(
  appChooserDialogStateInitial,

  on(
    AppChooserDialogActions.open,
    (state, { intentConfig, appConfigs }): AppChooserDialogState => ({
      ...state,
      isOpen: true,
      intentConfig,
      appConfigs,
    }),
  ),

  on(
    AppChooserDialogActions.close,
    (state): AppChooserDialogState => ({
      ...state,
      isOpen: false,
      intentConfig: undefined,
      appConfigs: [],
    }),
  ),

);
